import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
import { AchooPieChartComponent } from '../../../../core/achoo-pie-chart/achoo-pie-chart.component';
import { TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { chartConfig } from '../../../../app.constants';
import { SponsoredOrganicPercentage } from '../../../../../models/influencer';

@Component({
    selector: 'sponsored-vs-organic',
    templateUrl: './sponsored-vs-organic.component.html',
    styleUrls: ['./sponsored-vs-organic.component.scss']
})
export class SponsoredVsOrganicComponent extends AchooPieChartComponent implements OnInit, OnChanges {
    public chart: any;
    public options: any;

    public organicColor: string;
    public organicPercentage: number;
    public sponsoredColor: string;
    public sponsoredPercentage: number;
    public hasNoData: boolean;

    private readonly _placeholderData = [
        {
            name: 'all',
            x: 1,
            y: 100,
            color: 'rgba(149,160,177, 0.1)'
        }
    ];

    public overridenPiePlotOptions = {
        borderWidth: 0
    };

    @Input() sponsoredOrganicPercentage: SponsoredOrganicPercentage[];
    @Input() printMode: boolean;
    @Input() isFetchingData: boolean;

    constructor(protected pdfService: PdfExportService,
        protected userService: UserService,
        protected translate: TranslateService,
        protected deviceService: DeviceDetectorService) {
        super(pdfService, userService, translate, deviceService);
    }

    ngOnInit() {
        this.organicColor = this.userService.chartColors[0];
        this.sponsoredColor = this.userService.chartColors[1];
        const { showPlaceholder,
            organicPercentage,
            sponsoredPercentage,
            chartData
        } = this.extractSponsoredOrganicPercentage(this.sponsoredOrganicPercentage);
        this.hasNoData = showPlaceholder;
        this.organicPercentage = organicPercentage;
        this.sponsoredPercentage = sponsoredPercentage;

        this.options = {
            chart: {
                height: this.height,
                type: chartConfig.type.pie,
                margin: [0, 0, 0, 0],
                spacingTop: 0,
                spacingBottom: 0,
                spacingLeft: 0,
                spacingRight: 0,
                style: {
                    fontFamily: chartConfig.font.light
                },
            },
            colors: this.userService.chartColors,
            tooltip: {
                enabled: false
            },
            plotOptions: {
                pie: {
                    size: '100%',
                    height: '100%',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: false,
                    borderWidth: 0
                },
                series: {
                    animation: !this.pdfService.exportingPdf
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            title: {
                text: ''
            },
            series: [{
                data: chartData,
                size: chartConfig.pieChart.size,
                innerSize: '72%'
            }]
        };
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.sponsoredOrganicPercentage) {
            const { showPlaceholder,
                organicPercentage,
                sponsoredPercentage,
                chartData
            } = this.extractSponsoredOrganicPercentage(changes.sponsoredOrganicPercentage.currentValue);
            this.hasNoData = showPlaceholder;
            this.organicPercentage = organicPercentage;
            this.sponsoredPercentage = sponsoredPercentage;

            if (this.chart) {
                this.chart.series[0].setData(chartData);
            }
        }
    }

    public saveInstance(chartInstance) {
        this.chart = chartInstance;
    }

    public clickLegend(legend) {
        if (!this.chart || this.hasNoData) {
            return;
        }
        this.chart.series[0].points.forEach((p) => {
            if (p.name.toLowerCase() === legend) {
                const isVisible = p.visible;
                const updatedPoint = Object.assign({}, p, {
                    visible: !isVisible
                });
                p.update(updatedPoint);
            }
        });
    }

    public hoverLegend(legend) {
        if (!this.chart || this.hasNoData) {
            return;
        }
        this.chart.series[0].points.forEach(p => {
            if (p.name.toLowerCase() === legend) {
                p.onMouseOver();
            }
        });
    }

    public isVisibleLegend(legend) {
        if (!this.chart) {
            return false;
        }
        const activePoint = this.chart.series[0].points.find(p => p.name.toLowerCase() === legend);
        return activePoint && activePoint.visible;
    }

    private extractSponsoredOrganicPercentage(value: SponsoredOrganicPercentage[]): {
        showPlaceholder: boolean,
        organicPercentage: number,
        sponsoredPercentage: number,
        chartData: any[]
    } {
        if (!Array.isArray(value) || value.length !== 2) {
            return {
                showPlaceholder: true,
                organicPercentage: null,
                sponsoredPercentage: null,
                chartData: this._placeholderData
            };
        }

        const organicPercentage = value.find(x => x.name === 'Organic').percent * 100;
        const sponsoredPercentage = 100 - organicPercentage;

        return {
            showPlaceholder: false,
            organicPercentage,
            sponsoredPercentage,
            chartData: [
                {
                    name: 'sponsored',
                    x: 0,
                    y: sponsoredPercentage,
                    color: this.userService.chartColors[1]
                },
                {
                    name: 'organic',
                    x: 1,
                    y: organicPercentage,
                    color: this.userService.chartColors[0]
                }
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/sponsored-vs-organic/sponsored-vs-organic.component.ts